import { TextStyle_TextAlignment } from 'ricos-schema';

const indentLevelToClassName = {
  0: "indentZero",
  1: "indentOne",
  2: "indentTwo",
  3: "indentThree",
  4: "indentFour",
  5: "indentFive",
  6: "indentSix"
};
const TO_DIR = {
  [TextStyle_TextAlignment.LEFT]: "ltr",
  [TextStyle_TextAlignment.RIGHT]: "rtl"
};
const alignmentToFlex = {
  [TextStyle_TextAlignment.LEFT]: "left",
  [TextStyle_TextAlignment.CENTER]: "center",
  [TextStyle_TextAlignment.RIGHT]: "right",
  [TextStyle_TextAlignment.JUSTIFY]: "flex-start"
};

export { TO_DIR, alignmentToFlex, indentLevelToClassName };
//# sourceMappingURL=consts.js.map
